{
    "warning": "انتباہ!",
    "message": "ایسا کوڈ درج یا پیسٹ نہ کریں جو آپ سمجھتے نہ ہوں۔\nیہ کنسول استعمال کرنے سے حملہ آوروں کو Self-XSS نامی حملے کے ذریعے آپ کی نقالی اور آپ کی معلومات چرانے کا موقع مل سکتا ہے۔"
}
